
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-phone"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"

      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-phone"
        tabindex="0"
        type="button"

        class="close close-btn"

        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>
    <div class="edit-nationality-body">
      @if (dialogData.isChildAgeNotProperForEmail==true) {
        <div role="alert" aria-label="error"
          class="page-error">
          <label>Please note, you cannot edit a connected account’s email address. Please get the connected user to login to their account and amend the email address themselves. </label>
        </div>
      }
      @if (dialogData.isDuplicateChildEmail==true) {
        <div role="alert" aria-label="error" class="page-error">
          <label>A user with specified ID already exists. Please choose a different one.</label>
        </div>
      }
      <div class="modal-form-group">

        <label class="dob-label">Email:</label>

        <input sanitizeInputForm class="form-input" [(ngModel)]="dialogData.childEmail" placeholder="Enter {{dialogData.fullName}}'s email"
          [formControl]="dialogData.childEmailControl" (input)=dialogData.onInputChildEmail()>

          @if (dialogData.childEmailControl.invalid) {
            <div class="red no-margin">
              @if (dialogData.childEmailControl.errors!.email && !dialogData.childEmailControl.errors!.required) {
                <div>
                  Sorry, that is not a valid email format
                </div>
              }
              @if (dialogData.childEmailControl.errors!.required && dialogData.childEmailControl.dirty) {
                <div>
                  Email is required
                </div>
              }
            </div>
          }

        </div>
        <div class="btn-container">
          <button role="button" tabindex="0" aria-label="save" class="send-button"
          (click)="dialogData.saveChildEmail(dialogData.childEmail)">Save</button>
        </div>
      </div>
